/* global bootstrap */
document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.salvar-cookies');
    if (!form) {
        return;
    }
    const submit = form.querySelector('button[type="submit"]');
    const textoSubmit = submit.textContent;
    const banner = document.querySelector('section.cookies');
    const modal = document.getElementById('modal-cookies');
    const buttons = document.querySelectorAll('.btn-aceita, .btn-rejeita, .salvar-cookies button[type="submit"]');
    const avisos = document.querySelectorAll('.cookies-status');
    const informar = mensagem => avisos.forEach(aviso => { aviso.textContent = mensagem; });
    let token = '';
    let salvando = false;

    function aplicar(dados) {
        form.querySelectorAll('input[type="checkbox"]').forEach(input => {
            input.checked = dados.cookies.includes(input.value);
        });
        banner.style.display = dados.pendente ? 'block' : 'none';
        document.dispatchEvent(new CustomEvent('cookies:atualizados', { detail: dados.cookies }));
    }

    async function consultar() {
        const response = await fetch(form.action, { credentials: 'same-origin', cache: 'no-store' });
        const dados = await response.json();
        if (!response.ok || !dados.success) {
            throw new Error('Falha ao consultar preferencias');
        }
        token = dados.token;
        return dados;
    }

    async function salvar(escolhas) {
        if (salvando) {
            return;
        }
        salvando = true;
        buttons.forEach(button => { button.disabled = true; });
        informar('');
        try {
            if (!token) {
                await consultar();
            }
            const body = new URLSearchParams({ token });
            escolhas.forEach(valor => body.append('cookies_aceitos[]', valor));
            const response = await fetch(form.action, { method: 'POST', body, credentials: 'same-origin', cache: 'no-store' });
            const dados = await response.json();
            if (!response.ok || !dados.success) {
                throw new Error('Falha ao salvar preferencias');
            }
            aplicar(dados);
            bootstrap.Modal.getInstance(modal)?.hide();
        } catch (error) {
            informar('Não foi possível salvar suas escolhas. Tente novamente.');
        } finally {
            salvando = false;
            submit.textContent = textoSubmit;
            buttons.forEach(button => { button.disabled = false; });
        }
    }

    document.querySelectorAll('.btn-aceita').forEach(button => {
        button.addEventListener('click', () => salvar(['ativo', 'funcional', 'analitico']));
    });
    document.querySelectorAll('.btn-rejeita').forEach(button => {
        button.addEventListener('click', () => salvar(['ativo']));
    });
    form.addEventListener('submit', event => {
        event.preventDefault();
        salvar(Array.from(new FormData(form).getAll('cookies_aceitos[]')));
    });
    modal.addEventListener('show.bs.modal', () => {
        consultar().then(aplicar).catch(() => {
            informar('Não foi possível consultar suas escolhas. Tente novamente.');
        });
    });
    buttons.forEach(button => { button.disabled = true; });
    consultar().then(aplicar).catch(() => { banner.style.display = 'block'; }).finally(() => {
        buttons.forEach(button => { button.disabled = false; });
    });
});
